import { Methods } from '../config';
import request from '../utils/Request';

const baseURL = 'masterdataClassification';

const masterdataClassificationService = {
  getClassificationByType: (type) => {
    return request({
      resource: `${baseURL}/type/${encodeURIComponent(type)}`,
    });
  },
  upsertMasterdataClassification: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}`,
      data,
    });
  },
};

export default masterdataClassificationService;
